import { GenericPaginatedListResponse, GenericResponse } from './main'

// active일 경우는 배경색도 변함
export type QuestionTickerType = 'default' | 'active' | 'none'
export type QuestionTickerSize = 'small' | 'medium' | 'large'
export type QuestionTickerState = 'normal' | 'default-correct' | 'default-wrong' | 'active-correct' | 'active-wrong'

export enum QuestionImageType {
  EMOJI = 'EMOJI',
  PICTURE = 'PICTURE',
}
export enum QuestionType {
  YEAR = 'year',
  NUMBER = 'number',
  TEXT = 'text',
  CHOICE = 'choice',
  LINEAR = 'linear',
  MULTI_SELECT = 'checkbox',
  DROPDOWN = 'dropdown',
}

export enum QuestionInstructionLocation {
  PLACEHOLDER = 'placeholder',
  LEFT = 'left',
  RIGHT = 'right',
  IMAGE = 'image',
  IMAGE_LEFT = 'image_left',
  IMAGE_RIGHT = 'image-right',
}

export enum QuestionGroupType {
  MBTI_HOST_PRE = 'mbti-host-pre',
  MBTI_HOST = 'mbti-host',
  MBTI_GUEST_PRE = 'mbti-guest-pre',
  MBTI_GUEST = 'mbti-guest',
  MBTI_FIT_INFO = 'mbti-fit-info',
  MBTI_FIT_PRE = 'mbti-fit-pre',
  MBTI_IDEAL_TYPE = 'mbti-ideal-type',
  IDEAL_TYPE_HOST = 'ideal-type-host',
  IDEAL_TYPE_GUEST = 'ideal-type-guest',
  MBTI_BEST_FRIEND = 'mbti-best-friend',
  FEEDBACK_MBTI_FIT_REPORT = 'feedback-mbti-fit-report',
  FAVOUR_TOURNAMENT = 'favour-tournament',
  FEEDBACK_FAVOUR_TOURNAMENT = 'feedback-favour-tournament',
  ATTACHMENT_TYPE = 'attachment-type',
  ATTACHMENT_TYPE_HOST = 'attachment-type-host',
  ATTACHMENT_TYPE_GUEST = 'attachment-type-guest',
  GUESS_ME = 'guess-me',
  IMAGE_GAME = 'image-game',
  HSP_HOST = 'hsp-host',
  HSP_GUEST = 'hsp-guest',
  EGEN_TETO_HOST_MALE = 'egen-teto-host-male',
  EGEN_TETO_GUEST_MALE = 'egen-teto-guest-male',
  EGEN_TETO_HOST_FEMALE = 'egen-teto-host-female',
  EGEN_TETO_GUEST_FEMALE = 'egen-teto-guest-female',
}

export interface Question {
  id: number
  title: string // '{firstname_from}님에게 {firstname_to}님은 어떤 사람인가요?'
  description: string
  answerOptions: QuestionAnswerOption[] | null // [ '1', '2', '3', '4', '5' ] or [ '가족', '친구', '연애적 호감이 있는 사람 / 썸', '연인', '직장 동료 / 업무적 관계', '지인', '기타 관계' ]
  instructions: QuestionInstruction[]
  type: QuestionType
  isRequired: boolean
  isAnswered?: boolean
  image?: string
}

export interface QuestionAnswerOption {
  id: number
  value: string
  isEtc: boolean
  etcPlaceholder: string
  isNextQuestionGroupExists?: boolean
}

export interface QuestionInstruction {
  content: string
  location: QuestionInstructionLocation
}

export interface QuestionPaginatedListResponse extends GenericPaginatedListResponse {
  data: Question[]
}

export interface QuestionListResponse extends GenericResponse {
  data: Question[]
}

export enum QuestionAnswerSetMetaRelationKey {
  DIRECTION = 'DIRECTION',
  ELAPSED_TIME = 'ELAPSED_TIME',
  STAGE = 'STAGE',
  EXCLUSION = 'EXCLUSION',
}

export interface QuestionAnswerSetMetaRelation {
  key: QuestionAnswerSetMetaRelationKey
  value: string | number
}

export interface QuestionAnswerSet {
  question: Question
  metaRelations: QuestionAnswerSetMetaRelation[]
}

export interface QuestionAnswer {
  id?: number
  options?: number[]
  target?: string
  value?: string | number
  isNextQuestionGroupExists?: boolean // 주로 피드백에서 사용. 답변에 따라 다음 질문이 달라지는 경우
  questionAnswerSet: QuestionAnswerSet[]
}

export interface QuestionGroup {
  id: number
  title: string
  description: string
  playCount: number
  questions: Array<{ title: string }>
  image: string
  bannerImage: string
  createdAt: string
  questionImageType?: QuestionImageType
}

export interface QuestionGroupListResponse extends GenericResponse {
  data: QuestionGroup[]
}

export interface QuestionGroupResponse extends GenericResponse {
  data: QuestionGroup
}

export interface QuestionState {
  questions: Question[]
  selectedCount?: number
}

export interface QuestionExcludeClickData {
  question: Question
  location: 'left' | 'right'
}

export interface QuestionExcludeData {
  leftQuestion: Question
  rightQuestion: Question
}
